import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import injectProps from 'recompose-scope/injectProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import bindHotKeys from 'coact-utils/bindHotKeys'
import interceptUpdater from 'coact-utils/interceptUpdater'

import controlEditor from 'coact/controlEditor'
import objectEditorEnhancer from 'coact/objectEditorEnhancer'

import { computeTotal, computeSummary } from './computeValue'

import EditorView from './Editor'


const Editor = scope(
  // schema, auth, db, page, uiSetting
  consumeProps({
    auth: object,
    db: object,
    page: object,
    schema: object,
    uiSetting: object,
  }),
  injectProps({
    validator: func,
    computer: func,
  }),

  withState('value', 'onChange', null),

  objectEditorEnhancer, // => spliter

  // x-auth, x-schema, x-db, x-page
  controlEditor, // => actions

  // x-uiSetting
  withProps(({ uiSetting, schema }) => ({
    ui: {
      title: schema.name,
      ...uiSetting.editor,
    },
  })), // => ui

  interceptUpdater('onChange', () => value => ({
    ...value,
    total: computeTotal(value),
    summary: computeSummary(value),
  })),

  withHandlers({
    printOrder: ({ saveEditing, gotoCreateDoc }) => () => {
      saveEditing().then(() => {
        window.print()
        gotoCreateDoc()
      })
    },
  }),

  bindHotKeys({
    printOrder: ['shift+enter', 'ctrl+p'],
  }),

  exposeProps([
    'value',
    'onChange',
    'schema',
    'spliter',

    'saveEditing',
    'cancelEditing',
    'routeToNewDoc',
    'printOrder',

    'ui',
  ]),
)(EditorView)

Editor.displayName = 'SalesOrderEditor'

export default Editor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/index.js